import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../../shared/models/component-messages/mapaAT/step2';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { CTRL_426 } from '../../../../validators/426/ctrl426';
import { CTRL_427 } from '../../../../validators/427/ctrl427';
import { CTRL_429 } from '../../../../validators/429/ctrl429';
import { FormMapaATControlNames } from '../../formMapaATControlNames';
import { AttributionFromMAPA } from '../../models/AttributionFromMAPA';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html'
})
export class Step2Component implements OnInit {

  @Input() attributionFromMAPA: AttributionFromMAPA;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

  public step2 = new Step2();
  public radioButtonValue: string;
  public infructueux = RadioCheckBoxEnum.infructueux;
  public sansSuite = RadioCheckBoxEnum.sansSuite;
  public attribueUnique = RadioCheckBoxEnum.attribueUnique;
  public attribueLots = RadioCheckBoxEnum.attribueLots;
  public lotsInfructueux = RadioCheckBoxEnum.lotsInfructueux;

  public rg2 = CTRL_426.id + '_1';
  public rg3 = CTRL_427.id + '_1';
  public rg4 = CTRL_429.id + '_1';

  constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private avisDataTransferService: AvisDataTransferService) { }

  ngOnInit(): void {
    const datePublication = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.avisInitial.datePublication;
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_426Names_json(datePublication) }));
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_427Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: FormMapaATControlNames.getCtrl_429Names_json() }));
    this.radioButtonValue = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.resultatAttribution;
  }

  getStepId() {
	  return this.uid + '_';
	}

  isNotEmptyOrNullOrUndefined(value): boolean {
		return (value !== undefined && value !== null && value !== '');
	}

  public getUid() {
    return this.uid + '_SepSep_AttributionFromMAPA';
  }

  public getUidDescriptionReduite() {
    return this.uid + '_SepSep_AttributionFromMAPA_SepSep_DescriptionReduite';
  }

  public getUidTypeAutresInfosATTR() {
    return this.uid + '_SepSep_AttributionFromMAPA_SepSep_TypeAutresInfosATTR';
  }

  public getUidTypeMontant() {
    return this.getUidTypeAutresInfosATTR() + '_valeurTotaleEstimee_SepSep_TypeMontant';
  }

  public getUidAttribution() {
    return this.uid + '_SepSep_AttributionFromMAPA_SepSep_Attribution';
  }
}
